/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Upload_Error_GenericInputs */

const vi_file_upload_error_generic = /** @type {(inputs: File_Upload_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải tệp lên thất bại. Vui lòng thử lại.`)
};

/**

* @param {File_Upload_Error_GenericInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const file_upload_error_generic = /** @type {((inputs?: File_Upload_Error_GenericInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Error_GenericInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_file_upload_error_generic(inputs)
});